import {useState} from 'react';
import APKUploadForm from './APKUploadForm';
import APKUploadList from './APKUploadList';

const APkUpload = () => {

    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <APKUploadForm addForm={setFromIsShown} update={upData}  sId={serviceId}/>
        ) : (
          <APKUploadList addForm={setFromIsShown} update={setUpData} sId={setServiceId} />
        )}
  
    </>
  )
}

export default APkUpload